"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ariaRefHelpers;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var x = 2147483648;
var baseId = Math.floor(Math.random() * x).toString(36) + Math.abs(Math.floor(Math.random() * x) ^ Date.now()).toString(36);
var count = 0;
function guid() {
  count = count + 1;
  return "".concat(baseId, "-").concat(count);
}
var callAsync = Promise.resolve().then.bind(Promise.resolve());
var shadowRootToSharedAccessibilityTargets = new Map();
var shadowRootToAccessibilityTargetsItemsQueue = new Map();
var shadowRootToAriaRefs = new Map();
var shadowRootToAriaRefsQueue = new Map();
function ariaRefHelpers(name, props) {
  if (typeof name !== 'string') {
    return {
      handleAriaAccessibility: function handleAriaAccessibility() {},
      ariaSetVnode: function ariaSetVnode() {},
      requiresRef: false
    };
  }
  /**
   * Array<{
   *   targetRef: AriaRef,
   *   id: string,
   *   ariaAttribute: string,
   *   callback?: (targetRef: AriaRef) => {},
   *   currentClone?: Element,
   *   element?: Element
   * }>
   */
  var accessibilityTargets = [];
  if (typeof name === 'string') {
    for (var propName in props) {
      if (propName.startsWith('aria-') && props[propName] && typeof props[propName].subscribe === 'function') {
        var id = "a".concat(guid());
        var targetRef = props[propName];
        props[propName] = id;
        accessibilityTargets.push({
          targetRef: targetRef,
          id: id,
          ariaAttribute: propName
        });
      }
    }
  }
  var ariaRef;
  if (props && props['now-aria-ref']) {
    ariaRef = props['now-aria-ref'];
    delete props['now-aria-ref'];
  }
  function createAriaRefHierarchy(node) {
    if (!node) {
      ariaRef.setCurrent(node);
      return;
    }
    var ariaRefShadowRoot = node.getRootNode();
    var ariaRefAssignments = shadowRootToAriaRefs.get(ariaRefShadowRoot);
    if (!ariaRefAssignments) {
      ariaRefAssignments = [];
      shadowRootToAriaRefs.set(ariaRefShadowRoot, ariaRefAssignments);
    }
    ariaRefAssignments.push({
      ariaRef: ariaRef,
      element: node
    });
    callAsync(function () {
      var ariaRefsQueue = shadowRootToAriaRefsQueue.get(ariaRefShadowRoot);
      if (!ariaRefsQueue) {
        ariaRefsQueue = [];
        shadowRootToAriaRefsQueue.set(ariaRefShadowRoot, ariaRefsQueue);
      }
      ariaRefsQueue.push(ariaRef);
      if (ariaRefsQueue.length === ariaRefAssignments.length) {
        shadowRootToAriaRefs.delete(ariaRefShadowRoot);
        shadowRootToAriaRefsQueue.delete(ariaRefShadowRoot);
        var assignments = ariaRefAssignments.reverse(); // Reverse so that children always come after parents
        var ariaRefToAssignment = new Map();
        for (var i = 0; i < assignments.length; i++) {
          var ariaRefAssignment = assignments[i];
          ariaRefToAssignment.set(ariaRefAssignment.ariaRef, ariaRefAssignment);
          // We know that a parent of an ariaRef will always be before
          // it in the refs array. We can use this knowledge to efficiently figure out
          // each ariaRef's parent ariaRef
          if (i > 0) {
            var possibleParentAriaRef = assignments[i - 1].ariaRef;
            while (possibleParentAriaRef) {
              if (possibleParentAriaRef.contains(ariaRefAssignment.element)) {
                possibleParentAriaRef.setChildQuerySelector(ariaRefAssignment.ariaRef, buildQuerySelector(ariaRefToAssignment.get(possibleParentAriaRef).element, ariaRefAssignment.element));
                ariaRefAssignment.ariaRef.setParentAriaRef(possibleParentAriaRef);
                break;
              }
              possibleParentAriaRef = possibleParentAriaRef.getParentAriaRef();
            }
          }
          ariaRefAssignment.ariaRef.setCurrent(ariaRefAssignment.element);
        }
      }
    });
  }
  function handleAriaAccessibility(node) {
    if (ariaRef) {
      createAriaRefHierarchy(node);
    }
    var _iterator = _createForOfIteratorHelper(accessibilityTargets),
      _step;
    try {
      var _loop = function _loop() {
        var item = _step.value;
        item.element = node;
        if (!node) {
          if (item.currentClone && item.currentClone.parentNode) {
            item.currentClone.parentNode.removeChild(item.currentClone);
            item.currentClone = null;
          }
          if (item.callback) {
            item.targetRef.unsubscribe({
              element: node,
              attribute: item.ariaAttribute
            });
            item.callback = null;
          }
          return 1; // continue
        }
        function callback(targetRef) {
          if (!targetRef || !targetRef.isSet()) {
            if (item.currentClone && item.currentClone.parentNode) {
              item.currentClone.parentNode.removeChild(item.currentClone);
              item.currentClone = null;
            }
            node.removeAttribute(item.ariaAttribute);
            return;
          } else {
            node.setAttribute(item.ariaAttribute, item.id);
          }

          // If the element and target are in the same shadowRoot, don't clone the target
          // but instead just add the id to the target
          if (node.getRootNode() === targetRef.getRootNode()) {
            var _id = targetRef.getAttribute('id');
            if (_id) {
              node.setAttribute(item.ariaAttribute, _id);
            } else {
              targetRef.setId(item.id);
            }
            return;
          }
          var sourceShadowRoot = node.getRootNode();
          var sharedAccessibilityTargets = shadowRootToSharedAccessibilityTargets.get(sourceShadowRoot);
          if (!sharedAccessibilityTargets) {
            sharedAccessibilityTargets = new Set();
            shadowRootToSharedAccessibilityTargets.set(sourceShadowRoot, sharedAccessibilityTargets);
          }
          sharedAccessibilityTargets.add(item);
          callAsync(function () {
            var targetShadowRoot = targetRef.getRootNode();
            var targetItemsWithSharedShadow = Array.from(sharedAccessibilityTargets).filter(function (t) {
              return t.targetRef.isSet() && t.targetRef.getRootNode() === targetShadowRoot;
            });
            var targetItemsSharedShadowQueue = shadowRootToAccessibilityTargetsItemsQueue.get(targetShadowRoot);
            if (!targetItemsSharedShadowQueue) {
              targetItemsSharedShadowQueue = new Set();
              shadowRootToAccessibilityTargetsItemsQueue.set(targetShadowRoot, targetItemsSharedShadowQueue);
            }
            targetItemsSharedShadowQueue.add(item);
            if (targetItemsSharedShadowQueue.size === targetItemsWithSharedShadow.length) {
              handleAccessibilityTargets(targetItemsSharedShadowQueue);
              shadowRootToSharedAccessibilityTargets.delete(sourceShadowRoot);
              shadowRootToAccessibilityTargetsItemsQueue.delete(targetShadowRoot);
            }
          });
        }
        ;

        // Subscribe for any changes to the aria ref so we can replace the cloned node
        item.callback = callback;
        item.targetRef.subscribe({
          element: node,
          attribute: item.ariaAttribute
        }, callback);
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        if (_loop()) continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  function ariaSetVnode(vnode) {
    for (var i = 0; i < accessibilityTargets.length; i++) {
      var item = accessibilityTargets[i];
      item.vnode = vnode;
    }
  }
  return {
    handleAriaAccessibility: handleAriaAccessibility,
    ariaSetVnode: ariaSetVnode,
    requiresRef: !!(ariaRef || accessibilityTargets.length)
  };
}
function handleAccessibilityTargets(targetItemsShadowQueue) {
  // Separate ariaRefs that do and do not have a parent.
  // Those without a parent are the refs that should be cloned
  var targetRefToTreeNode = new Map();
  var targetItemRoots = [];
  var targetItems = Array.from(targetItemsShadowQueue);
  var _loop2 = function _loop2() {
    var targetItem = targetItems[i];
    var treeNode = targetRefToTreeNode.get(targetItem.targetRef);
    if (!treeNode) {
      treeNode = {
        targetItems: [],
        children: [],
        targetRef: targetItem.targetRef,
        parentTargetRef: null
      };
      targetRefToTreeNode.set(targetItem.targetRef, treeNode);
    }
    treeNode.targetItems.push(targetItem);
    var parentAriaRef = targetItem.targetRef.getParentAriaRef();
    while (parentAriaRef) {
      if (targetItems.find(function (item) {
        return item.targetRef === parentAriaRef;
      })) {
        var parentNode = targetRefToTreeNode.get(parentAriaRef);
        if (!parentNode) {
          parentNode = {
            targetItems: [],
            children: [],
            targetRef: parentAriaRef,
            parentTargetRef: null
          };
          targetRefToTreeNode.set(parentAriaRef, parentNode);
        }
        treeNode.parentTargetRef = parentAriaRef;
        parentNode.children.push(targetItem);
        break;
      }
      parentAriaRef = parentAriaRef.getParentAriaRef();
    }
    if (!parentAriaRef) targetItemRoots.push(targetItem);
  };
  for (var i = 0; i < targetItems.length; i++) {
    _loop2();
  }

  // Loop over targetItemRoots:
  // For each one, if it hasn't been cloned yet, clone into DOM and then for each child:
  // If it hasn't been handled yet, create the query selector from the child targetRef to the
  // parent targetRef, then use that selector on the cloned item, then edit the returned element
  // to have the correct id
  var cloned = new Map();
  var targetRefToQuerySelector = new Map();
  for (var _i = 0; _i < targetItemRoots.length; _i++) {
    var rootTargetItem = targetItemRoots[_i];
    var firstItemWithTargetRef = cloned.get(rootTargetItem.targetRef);
    rootTargetItem.element.setAttribute(rootTargetItem.ariaAttribute, firstItemWithTargetRef ? firstItemWithTargetRef.id : rootTargetItem.id);
    if (!firstItemWithTargetRef) {
      cloned.set(rootTargetItem.targetRef, rootTargetItem);
      var clone = rootTargetItem.targetRef.cloneNode(true);
      clone.id = rootTargetItem.id;
      clone.setAttribute('aria-hidden', true);
      var container = document.createElement('div');
      container.style = 'position: absolute; overflow: hidden; width: 1px; height: 1px; margin: 0; border: none; padding: 0; white-space: nowrap; clip: rect(0 0 0 0); clip-path: inset(50%);';
      container.appendChild(clone);
      if (rootTargetItem.currentClone && rootTargetItem.currentClone.parentNode) rootTargetItem.currentClone.parentNode.removeChild(rootTargetItem.currentClone);
      rootTargetItem.element.getRootNode().appendChild(container);
      rootTargetItem.currentClone = container;
    }
    var children = _toConsumableArray(targetRefToTreeNode.get(rootTargetItem.targetRef).children);
    targetRefToQuerySelector.set(rootTargetItem.targetRef, '');
    while (children.length) {
      var childItem = children.shift();
      var _firstItemWithTargetRef = cloned.get(childItem.targetRef);
      var itemId = _firstItemWithTargetRef ? _firstItemWithTargetRef.id : childItem.id;
      childItem.element.setAttribute(childItem.ariaAttribute, itemId);
      if (!_firstItemWithTargetRef) {
        cloned.set(childItem.targetRef, childItem);
        var treeNode = targetRefToTreeNode.get(childItem.targetRef);
        var selections = [];
        var currentParent = void 0;
        var currentChild = childItem.targetRef;
        do {
          currentParent = currentChild.getParentAriaRef();
          var partialSelector = currentParent.getChildQuerySelector(currentChild);
          selections.push(partialSelector);
          currentChild = currentParent;
        } while (currentParent !== rootTargetItem.targetRef);
        var selector = selections.reverse().join(' > ');
        var node = rootTargetItem.currentClone.querySelector(selector);
        node.id = itemId;
        children = children.concat(treeNode.children);
      }
    }
  }
}
function buildQuerySelector(parent, child) {
  var path = [];
  var el = child;
  while (el !== parent) {
    var position = 0;
    var current = el;
    while (current) {
      if (current.tagName === el.tagName) position += 1;
      current = current.previousElementSibling;
    }
    path.push("".concat(el.tagName.toLowerCase(), ":nth-of-type(").concat(position, ")"));
    el = el.parentNode;
  }
  return path.reverse().join(' > ');
}